import React from 'react';

import { TimelinePlayhead } from './timeline-playhead';

type AdvancedTimelineOverlaysProps = {
  outputTimeSec: number;
  playbackPlayheadPositionPx: number;
  trimPreviewPositionPx: number | null;
  trimPreviewTimeMs: number | null;
  isTrimPreviewNearLeft: boolean;
  isTrimPreviewNearRight: boolean;
  rulerHeightPx: number;
  trackHeightPx: number;
  formatTimeWithMs: (timeSec: number) => string;
  onPlaybackPlayheadMouseDown?: (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => void;
};

export const AdvancedTimelineOverlays = ({
  outputTimeSec,
  playbackPlayheadPositionPx,
  trimPreviewPositionPx,
  trimPreviewTimeMs,
  isTrimPreviewNearLeft,
  isTrimPreviewNearRight,
  rulerHeightPx,
  trackHeightPx,
  formatTimeWithMs,
  onPlaybackPlayheadMouseDown,
}: AdvancedTimelineOverlaysProps): React.JSX.Element => {
  return (
    <>
      <TimelinePlayhead
        outputTimeSec={outputTimeSec}
        positionPx={playbackPlayheadPositionPx}
        topOffsetPx={0}
        heightPx={rulerHeightPx + trackHeightPx}
        onMouseDown={onPlaybackPlayheadMouseDown}
      />
      {trimPreviewPositionPx != null && trimPreviewTimeMs != null && (
        <div
          className="pointer-events-none absolute z-20"
          style={{
            left: `${trimPreviewPositionPx}px`,
            top: `${rulerHeightPx}px`,
            height: `${trackHeightPx}px`,
          }}
          data-testid="timeline-trim-preview"
        >
          <div
            className={`absolute -top-5 whitespace-nowrap rounded bg-spring-primary px-1.5 py-0.5 text-[10px] text-white ${
              isTrimPreviewNearLeft
                ? 'left-0 translate-x-0'
                : isTrimPreviewNearRight
                ? 'right-0 -translate-x-full'
                : '-translate-x-1/2'
            }`}
          >
            {formatTimeWithMs(trimPreviewTimeMs / 1000)}
          </div>
          <div className="h-full w-px bg-spring-primary" />
        </div>
      )}
    </>
  );
};
